import bus from '../events/bus';
import closest from '../utils/closest';

let attachEvents = true;

function selectDisclaimer(event) {
  if (event.target.getAttribute && event.target.getAttribute('data-disclaimer')) {
    event.preventDefault();
    const disclaimerId = event.target.getAttribute('data-disclaimer');
    const disclaimerCopy = event.target.getAttribute('data-copy');
    const disclaimerTitle = event.target.getAttribute('data-title');
    bus.trigger(bus.EVENTS.DISCLAIMER.OPENDISCLAIMER,
      { disclaimerId, disclaimerCopy, disclaimerTitle });
  } else if (!closest(event.target, 'offer-notification')) {
    bus.trigger(bus.EVENTS.DISCLAIMER.CLOSEDISCLAIMER);
  }
}

export default function () {
  if (attachEvents) {
    document.getElementsByTagName('body')[0].removeEventListener('click', selectDisclaimer);
    document.getElementsByTagName('body')[0].addEventListener('click', selectDisclaimer);
    attachEvents = false;
    // console.log("here");
  }
}
